<template>
    <form @submit.prevent="validarFormulario()"
          data-vv-scope="sga"
          class="padding-content"
    >
        <div class="row padding-content shadow-sm bg-gray-50">
            <strong>SGA para el producto</strong>

            <br />
        <b-row class="mb-3">
            <b-col md="6" sm="12">
                <b-badge v-text="'Peligros Físicos'"
                         class="w-100 badge-sga badge-fisicos"
                />
                <el-select v-model="sga.categoriasfisicas"
                           id="categoriasfisicas"
                           name="categoriasfisicas"
                           class="my-1"
                           multiple
                           clearable
                           filterable
                           v-validate="'required'"
                           data-vv-as=" "
                           @change="valores(sga.categoriasfisicas, 'fisicas')"
                >
                    <el-option v-for="(fisico, index) in fisicos"
                               :key="index"
                               :value="fisico.id"
                               :label="fisico.categoria"
                    />
                </el-select>

                <span class="text-danger span-error small"
                      v-text="errors.first('sga.categoriasfisicas')"
                />
            </b-col>

            <b-col md="6" sm="12">
                <b-badge v-text="'Peligros de Salud'"
                         class="w-100 badge-sga badge-salud"
                />
                <el-select v-model="sga.categoriassalud"
                           id="categoriassalud"
                           name="categoriassalud"
                           class="my-1"
                           multiple
                           clearable
                           filterable
                           v-validate="'required'"
                           data-vv-as=" "
                           @change="valores(sga.categoriassalud, 'salud')"
                >
                    <el-option v-for="(saludcat, index) in salud"
                               :key="index"
                               :value="saludcat.id"
                               :label="saludcat.categoria"
                    />
                </el-select>

                <span class="text-danger span-error small"
                      v-text="errors.first('sga.categoriassalud')"
                />
            </b-col>

            <b-col md="6" sm="12">
                <b-badge v-text="'Peligros en el Ambiente'"
                         class="w-100 badge-sga badge-ambiente"
                />
                <el-select v-model="sga.categoriasambiental"
                           id="categoriasambiental"
                           name="categoriasambiental"
                           class="my-1"
                           multiple
                           clearable
                           filterable
                           v-validate="'required'"
                           data-vv-as=" "
                           @change="valores(sga.categoriasambiental, 'ambiental')"
                >
                    <el-option v-for="(ambiente, index) in ambiental"
                            :key="index"
                            :value="ambiente.id"
                            :label="ambiente.categoria"
                    />
                </el-select>

                <span class="text-danger span-error small"
                    v-text="errors.first('sga.categoriasambiental')"
                />
            </b-col>

            <b-col md="6" sm="12">
                <b-badge v-text="'Sustancias no peligrosas'"
                         class="w-100 badge-sga badge-no-peligrosas"
                />
                <el-select v-model="sga.categoriasNpeligrosas"
                           id="categoriasNpeligrosas"
                           name="categoriasNpeligrosas"
                           class="my-1"
                           multiple
                           clearable
                           filterable
                           v-validate="'required'"
                           data-vv-as=" "
                           @change="valores(sga.categoriasNpeligrosas, 'nopeligrosas')"
                >
                    <el-option v-for="(peligrosa, index) in getNonHazardousSubstances"
                               :key="index"
                               :value="peligrosa.id"
                               :label="peligrosa.categoria"
                    />

                </el-select>
                <span class="text-danger span-error small"
                    v-text="errors.first('sga.categoriasNpeligrosas')"
                />
            </b-col>
        </b-row>
        </div>
        <br />
        <b-row>
            <b-col>
                <button class="btn btn-secondary float-left"
                        @click="setModalPaso(2)"
                >
                    Anterior
                </button>
                <button class="btn btn-primary float-right"
                        @click="validarFormulario()"
                >
                    Siguiente
                </button>
                <button class="btn btn-secondary float-right mr-2"
                        @click="setModalVer(false)"
                >
                    Cancelar
                </button>
            </b-col>
        </b-row>
    </form>
</template>

<script>

// Importaciones generales
import Vue from 'vue';
import VeeValidate, {Validator} from 'vee-validate';
import es from 'vee-validate/dist/locale/es';
import { mapState, mapActions, mapMutations } from 'vuex';

Vue.use(VeeValidate, {
    fieldsBagName: 'vvFields',
    events: 'change',
});

Validator.localize('es', es);

export default {
    name: 'general',
    data() {
        return {
            valuesNoApply: {
                environmental: false,
                physical: false,
                health: false,
            }
        }
    },
    async mounted() {
        await this.getJsonSga();

        this.getValuesNoApply();
    },
    computed: {
        ...mapState('pasoapaso', ['fisicos', 'salud', 'ambiental', 'peligrosas', 'sga']),
        /**
         * Vlidaciones para usar sustencias no peligrosas
         * @author Fernando CLaros
         */
        verifySgaHasNoApply() {

            let environmental =  false
            let physical =  false
            let health =  false
            
            if (this.valuesNoApply.environmental && typeof this.sga.categoriasambiental === 'object') {
                const hasEnvironmental = this.sga.categoriasambiental.find(x => x == this.valuesNoApply.environmental.id)
                if (hasEnvironmental || this.sga.categoriasambiental.length == 0) environmental = true
                if (this.sga.categoriasambiental.length > 0 && !hasEnvironmental) environmental = false
            }
            if (this.valuesNoApply.physical && typeof this.sga.categoriasfisicas === 'object') {
                const hasPhysical = this.sga.categoriasfisicas.find(x => x == this.valuesNoApply.physical.id)
                if (hasPhysical || this.sga.categoriasfisicas.length == 0) physical = true
                if (this.sga.categoriasfisicas.length > 0 && !hasPhysical) physical = false
            }
            if (this.valuesNoApply.health && typeof this.sga.categoriassalud === 'object') {
                const hasHealth = this.sga.categoriassalud.find(x => x == this.valuesNoApply.health.id)
                if (hasHealth || this.sga.categoriassalud.length == 0) health = true
                if (this.sga.categoriassalud.length > 0 && !hasHealth) health = false
            }

            // limpiar las no peligrosas
            this.sga.categoriasNpeligrosas = []

            return (!environmental || !physical || !health) ? false : true;
        },
        /**
         * Sustancias no peligrosas
         * @author Fernando CLaros
         */
        getNonHazardousSubstances() {

            return this.peligrosas.filter(x => this.verifySgaHasNoApply ?
                x.codigo != "NA" :
                x.codigo == "NA"
            )
        
        }
    },
    methods: {
        ...mapActions('pasoapaso', ['getJsonSga']),
        ...mapMutations('pasoapaso', ['setModalPaso', 'setModalVer']),
        getValuesNoApply() {

            this.valuesNoApply.physical = this.fisicos.find(x => x.codigo == "NA")
            this.valuesNoApply.health = this.salud.find(x => x.codigo == "NA")
            this.valuesNoApply.environmental = this.ambiental.find(x => x.codigo == "NA")

        },
        validarFormulario() {
            this.$validator.validateAll('sga').then((result) => {
                if (result) {
                    this.setModalPaso(4);
                }
            });
        },
        async valores(sga, tipo) {
            if (tipo === 'fisicas') {
                for (let i = 0; i < sga.length; i++) {
                    // Si es 1 significa que no aplica
                    if (sga[i] == 1) {
                        this.sga.categoriasfisicas = [];
                        this.sga.categoriasfisicas.push(1);
                    }
                }
            }
            if (tipo === 'salud') {
                for (let i = 0; i < sga.length; i++) {
                    if (sga[i] == 51) {
                        this.sga.categoriassalud = [];
                        this.sga.categoriassalud.push(51);
                    }
                }
            }
            if (tipo === 'ambiental') {
                for (let i = 0; i < sga.length; i++) {
                    if (sga[i] == 92) {
                        this.sga.categoriasambiental = [];
                        this.sga.categoriasambiental.push(92);
                    }
                }
            }
            if (tipo === 'nopeligrosas') {
                for (let i = 0; i < sga.length; i++) {
                    if (sga[i] == 101) {
                        this.sga.categoriasNpeligrosas = [];
                        this.sga.categoriasNpeligrosas.push(101);
                    }
                }
            }
        },
    },
};
</script>

<style>

.padding-content{
    padding: 20px;
}

.uppercase {
    text-transform: uppercase !important;
}

.uppercase textarea {
    text-transform: uppercase !important;
}

.badge-sga {
    border-radius: 8px;
    height: 40px;
    color: white;
    padding: 14px;
    font-size: 14px;
    margin-top: 15px;
}

.badge-fisicos {
    background-color: #ff7d00;
}

.badge-salud {
    background-color: #1f487b;
}

.badge-ambiente {
    background-color: #36b564;
}

.badge-no-peligrosas {
    background-color: #55b543;
}
</style>
